import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { getDeviceInventoryCount, SearchSchema } from '@/features/device/inventory';
export const Route = createFileRoute('/_staff/devices/_list/inventories/')({
  validateSearch: zodValidator(SearchSchema),
  loader: () => getDeviceInventoryCount()
});